import { useContext } from "react";
import { AuthContext } from "./AuthProvider";
import { AuthContextType } from "./types";

export const useAuth = (): { auth: AuthContextType; initialized: boolean } => {
  const auth = useContext(AuthContext);
  return {
    auth: auth,
    initialized: auth.initialized,
  };
};
